import debounce from './debounce'
import loadMore from './loadMore'
import clickOutside from 'element-ui/src/utils/clickoutside'

const install = Vue => {
  Vue.directive('debounce', debounce)
  Vue.directive('loadMore', loadMore)
  Vue.directive('clickOutside', clickOutside)
}
export default {
  install
}
